import React from 'react';
import { defineBlock, useSmartProp, smartProps, useInspectorControl, EditableText, EditableImg, useEditor, ChildrenBlock } from '@smartfire/gutenberg-react';
import { InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, PanelRow, ToggleControl } from '@wordpress/components';
import style from './block.module.scss';

const ALLOWED_BLOCKS = ['core/heading', 'core/paragraph', 'core/image'];
const MY_TEMPLATE = [
    ['core/heading', {placeholder: 'Insérez le titre'}],
    ['core/paragraph', {placeholder: 'Insérez le texte'}],
]

function Inspector() {
    const [typeElement, setTypeElement] = useSmartProp('typeElement');

    return <>
        <PanelBody title="Picto ou chiffre" initialOpen={true}>
            <PanelRow>
                <ToggleControl 
                    label={typeElement ? 'Chiffre' : 'Picto'}
                    checked={typeElement}
                    onChange={(e) => setTypeElement(e)}
                />
            </PanelRow>
        </PanelBody>
    </>
}

function Block({typeElement}) {
    useInspectorControl(Inspector);
    const {isEditing} = useEditor();

    return (
        <div className={style.block}>
            {typeElement ? 
                <EditableText
                    tagName={"span"}
                    smartProp="numbers"
                    className={style.numbers}
                    placeholder={"..."}
                />
                : 
                <EditableImg 
                    smartProp="image"
                    className={style.image}
                />
            }
            {isEditing ? 
                <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } />
                :
                <ChildrenBlock />
            }
        </div>
    )
}

export default defineBlock({
    Block,
    smartProps: {
        typeElement: smartProps.bool.withDefault(true),
        image: smartProps.image,
        numbers: smartProps.string.withDefault('',)
    },
    setup: {
        title: 'Chiffres/pictos item',
        parent: ['smartfire/chiffres-pictos'],
    }
})